import { useEffect, useState } from 'react';
import { Card, Grid, Snackbar, Typography } from '@mui/material';
import { NotificationDto } from '@inosio/payments-sdk';
import { getSupportedNotifications, selectNotificationSettingsState } from './sagas/notificationSettingSlice';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationTab } from './components/notificationTab';

export default function NotificationSettings() {
  const dispatch = useDispatch();
  const {
    supportedNotifications,
    isCreatingNotificationSubscriptionSuccess,
    isCreatingNotificationSubscriptionFailed,
    isDeletingNotificationSubscriptionSuccess,
    isDeletingNotificationSubscriptionFailed,
  } = useSelector(selectNotificationSettingsState);
  const [showToast, setShowToast] = useState(false);

  //on load fetch all supported notifications for this user
  useEffect(() => {
    dispatch({ type: getSupportedNotifications.type });
  }, [dispatch]);

  //listen for successful creation/deletion of notification subscription and fetch a fresh copy of supported notifications
  useEffect(() => {
    if (isCreatingNotificationSubscriptionSuccess || isDeletingNotificationSubscriptionSuccess) {
      dispatch({ type: getSupportedNotifications.type });
    }
  }, [isCreatingNotificationSubscriptionSuccess, isDeletingNotificationSubscriptionSuccess]);

  useEffect(() => {
    setShowToast(isCreatingNotificationSubscriptionFailed);
  }, [isCreatingNotificationSubscriptionFailed, isDeletingNotificationSubscriptionFailed]);

  useEffect(() => {
    setShowToast(isDeletingNotificationSubscriptionFailed);
  }, [isDeletingNotificationSubscriptionFailed]);

  const supportedNotificationsList = supportedNotifications.filter((notification) => !notification.frequency.includes('option'));
  let paymentSummaryOption = { ...supportedNotifications.find((report) => report.frequency.includes('Payment summary option')) } as NotificationDto;
  if (paymentSummaryOption) paymentSummaryOption.title = 'Include pdf per deposit';

  return (
    <Grid item xs={12} sx={{ mt: 3.5 }}>
      <Card sx={{ width: '100%' }}>
        <Card sx={{ m: 3, minHeight: '75vh' }}>
          <Typography sx={{ p: 2, background: '#053742', color: '#fff', fontWeight: 600, fontFamily: 'Work Sans, sans-serif' }}>Email Reports</Typography>
          {supportedNotificationsList &&
            supportedNotificationsList.map((notification, index) => {
              if (notification.title.includes('Daily Payment Summary')) return <NotificationTab key={index} {...notification} additionalOption={paymentSummaryOption} />;
              return <NotificationTab key={index} {...notification} />;
            })}

          <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={showToast} autoHideDuration={1000} onClose={() => setShowToast(false)} message="Request Failed" />
        </Card>
      </Card>
    </Grid>
  );
}
